export default __webpack_public_path__ + "./fonts/rejectAuthorizations.5dc847a4.svg";